<template>
  <v-app
    :style="cssProps"
  >

    <v-app-bar
      app
      v-if="isReady"
      clipped-left
      color="#27402e"
    >
      <v-toolbar-title style="margin-right:0px; margin-top:10px" class="black--text flex text-center"><img width="130px" src="@/assets/blokhutwinkel-logo.png"/></v-toolbar-title>
    </v-app-bar>

    <v-main v-if="isReady">
      <v-container >
        <router-view></router-view>
      </v-container>
    </v-main>

    <Loading
      :active="!isReady"
      :can-cancel="false"
      :color="$vuetify.theme.currentTheme.primary"
      background-color="#000000"
      :opacity="1"
      :is-full-page="true"
      loader="dots"
      :width="64"
      :height="64"
    ></Loading>  

    <Loading
      :active="isActive" 
      :can-cancel="true"
      :on-cancel="cancel"
      :color="$vuetify.theme.currentTheme.primary"
      background-color="#000000"
      :opacity="0.5"
      :is-full-page="true"
      loader="dots"
      :width="64"
      :height="64"
    ></Loading>  

    <v-footer>
      
        <v-col cols="12" style="background-color:#27402e;">
          <div style="padding: 5px; font-size: 14px; margin-left:50px; margin-bottom:15px; color:#FFFFFF; background-color:#27402e;">
          Service &amp; contact <br/>
            <table>
              <tr>
                <td style="vertical-align:top">
                  <v-icon
                  left
                  dark
                  >
                  fal fa-recycle
                  </v-icon>
                </td>
                <td style="vertical-align:top">
                  Info@blokhutwinkel.nl<br />
                  0575 - 200 200 <br />
                </td>
              </tr>
            </table>
          </div>
        </v-col>
      
        <v-col cols="12" style="background-color:#eaeaea;"  
            align="center"
            justify="center">
          <div style="padding: 5px; font-size: 14px; margin-bottom:15px; color:#7e7e7e;">
            <a style="text-decoration: none; color:#7e7e7e;" target="_blank" href="https://blokhutwinkel.nl">blokhutwinkel.nl</a> | 
            <a style="text-decoration: none; color:#7e7e7e;" target="_blank" href="https://www.blokhutwinkel.nl/algemene-voorwaarden">Algemene voorwaarden</a> <br /><br />
              
              <v-btn icon href="https://nl-nl.facebook.com/blokhutwinkel.nl" target="_blank">
                <v-icon style="margin-right:10px"
                  color="grey"
                >
                fab fa-facebook-square
                </v-icon>
              </v-btn>              

              <v-btn icon href="https://nl.pinterest.com/blokhutwinkel/" target="_blank">
                <v-icon style="margin-right:10px"
                  color="grey"
                >
                fab fa-pinterest-square
                </v-icon>
              </v-btn>              

              <v-btn icon href="https://www.youtube.com/user/blokhutwinkel" target="_blank">
                <v-icon style="margin-right:10px"
                  color="grey"
                >
                fab fa-youtube-square
                </v-icon>
              </v-btn>                          

              <v-btn icon href="http://twitter.com/blokhut_kopen" target="_blank">
                <v-icon style="margin-right:10px"
                  color="grey"
                >
                  fab fa-twitter-square
                </v-icon>
              </v-btn>              

              <v-btn icon href="https://www.instagram.com/blokhutwinkel.nl/" target="_blank">
                <v-icon style="margin-right:10px"
                  color="grey"
                >
                  fab fa-instagram-square
                </v-icon>
              </v-btn>              
          </div>
        </v-col>     
    </v-footer>
  </v-app>
</template>

<script>
import useAuth from '@/use/auth'
import useLoader from '@/use/loader'
import useApp from '@/use/app'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { ref, computed } from '@vue/composition-api'

export default {
  components: {
    Loading,
  },
  setup(props, context) {
    const { authenticate, ping, user, isReady, isLoggedIn, logout } = context.root.$api.auth
    const { cancel, isActive } = useLoader()
    const { drawer, title, setTitle } = useApp()
/*
    authenticate().then(() => {
      //ping()
    })
  */
 
    const query = ref('')

    const cssProps = computed(() => ({
      '--error-color': context.root.$vuetify.theme.currentTheme.error,
      '--info-color': context.root.$vuetify.theme.currentTheme.info,
      '--primary-color': context.root.$vuetify.theme.currentTheme.primary,
      '--secondary-color': context.root.$vuetify.theme.currentTheme.secondary,
      '--success-color': context.root.$vuetify.theme.currentTheme.success,
      '--warning-color': context.root.$vuetify.theme.currentTheme.warning,

      '--accent-color': context.root.$vuetify.theme.currentTheme.accent,
      '--background-color': context.root.$vuetify.theme.currentTheme.background,
      '--dialog-background-color': context.root.$vuetify.theme.currentTheme.dialogBackground,
      'background-color': context.root.$vuetify.theme.currentTheme.background,
    }))

    function doLogout() {
      drawer.value = false
      logout()
    }

    context.root.$router.afterEach((to, from) => {
      setTitle(to.meta.title || '')
    })
    
    return {
      cssProps,
      isActive,
      isReady,
      isLoggedIn,
      title,
      drawer,
      doLogout,
      user,
      cancel,
      query,
    }
    
  },

}
</script>

<style>
.bg-wood {
  background: url('./assets/bg-login.jpg') no-repeat fixed center !important;
}

div:has(> input[required]) label:after {
  color: #B71C1C;
  content: " *";
}



</style>
